export enum RepositionType {
  Base = 'Base',
  OBRepo = 'OBRepo',
  IBRepo = 'IBRepo',
}
